import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import uploadImg from "../../assets/images/upload.svg";
import CountrySelect from "../../component/countrySelect";
import api from "../../api";
import { notify } from "../../utils/toast";
export const AddEmployee = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [phoneNum, setPhoneNum] = useState("");
  const [phoneNumEmerg, setPhoneNumEmerg] = useState("");

  const onTextChange = (e, type) => {
    if (e.label) {
      setData({ ...data, nationality: e.label });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  const onPDFChange = async (e) => {
    try {
      setLoader(true);

      const formData = new FormData();
      formData.append("pdf", e.target.files[0], e.target.files[0].name);
      const uploadRes = await api.uploadPDF(formData);
      console.log(uploadRes);
      if (uploadRes?.success) {
        setData({
          ...data,
          [e.target.name]: `${uploadRes?.fileName}`,
        });
      }
      setLoader(false);
    } catch (e) {
      notify.error("File upload failed!");

      setLoader(false);
      console.log(e.message);
    }
  };

  const validateData = () => {
    if (!data?.fullName) {
      return "please add Full Name";
    } else if (!data?.dob) {
      return "Please add Date of Birth";
    } else if (!data?.gender) {
      return "Please select gender";
    } else if (!data?.nationality) {
      return "please select nationality";
    } else if (!phoneNum) {
      return "please add contact number ";
    } else if (!phoneNum) {
      return "please add emergency contact number ";
    } else if (!data?.email) {
      return "please add email ";
    } else if (!data?.jobTitle) {
      return "please add job title ";
    } else if (!data?.department) {
      return "please select department ";
    } else if (!data?.employmentType) {
      return "please select employment type ";
    } else if (!data?.workLocation) {
      return "please select work location ";
    } else if (!data?.joiningDate) {
      return "please add joining date ";
    } else if (!data?.workingHoursPolicy) {
      return "please enter working hours policy ";
    } else if (!data?.overtimeEligibility) {
      return "please select overtime eligibility ";
    }
    return "";
  };

  const handleSubmit = async () => {
    try {
      const validator = validateData();
      if (validator) {
        notify.warning(validator);
        return;
      }
      let payload = {
        fullName: data?.fullName,
        dob: data?.dob,
        gender: data?.gender,
        nationality: data?.nationality,
        address: data?.address || "",
        contactNumber: phoneNum,
        emergencyNumber: phoneNumEmerg,
        email: data?.email,
        password: data?.password,

        jobTitle: data?.jobTitle,
        department: data?.department,
        employmentType: data?.employmentType,
        joiningDate: data?.joiningDate,
        contractEndDate: data?.contractEndDate || "",
        workLocation: data?.workLocation,

        baseSalary: data?.baseSalary || "",
        currency: data?.currency || "",
        bankAccountHolderName: data?.bankAccountHolderName || "",
        bankName: data?.bankName || "",
        accountNumber: data?.accountNumber || "",
        swiftCode: data?.swiftCode || "",
        taxId: data?.taxId || "",

        workingHoursPolicy: data?.workingHoursPolicy,
        overtimeEligibility: data?.overtimeEligibility,

        documents: {
          nationalId: data?.nationalId || "",
          contract: data?.contract || "",
          otherDocument: data?.otherDocument || "",
        },
      };

      console.log(payload);
      const response = await api.addEmployee(payload);
      console.log(response);
      if (response?.success) {
        notify.success("Employee successfully added");
        setData({});
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        {/* 1. personal deatil */}
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="titleRow">
                <div className="title">1. Personal Info</div>
                <div className="req">Required</div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                      name="fullName"
                      value={data?.fullName}
                      onChange={(e) => onTextChange(e)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Date Of Birth *</label>
                    <input
                      type="date"
                      className="form-control"
                      value={data?.dob}
                      onChange={(e) => onTextChange(e)}
                      name="dob"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Gender *</label>
                    <select
                      name="gender"
                      value={data?.gender}
                      onChange={(e) => onTextChange(e)}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Nationality *</label>
                    <CountrySelect onTextChange={onTextChange} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group phone mb-3">
                    <label>Contact *</label>
                    <PhoneInput
                      className="form-control PhoneInput"
                      international
                      countryCallingCodeEditable={false}
                      value={phoneNum}
                      onChange={setPhoneNum}
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group phone mb-3">
                    <label>Emergency Contact *</label>
                    <PhoneInput
                      className="form-control PhoneInput"
                      international
                      countryCallingCodeEditable={false}
                      value={phoneNumEmerg}
                      onChange={setPhoneNumEmerg}
                      placeholder="Emergency Phone Number"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Email *</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Email"
                      onChange={(e) => onTextChange(e)}
                      name="email"
                      value={data?.email}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label>Password *</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter Password"
                      onChange={(e) => onTextChange(e)}
                      name="password"
                      value={data?.password}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group mb-3">
                    <label>Address</label>
                    <textarea
                      name="address"
                      value={data?.address}
                      className="form-control"
                      placeholder="Enter Address Here"
                      onChange={(e) => onTextChange(e)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 2. Employement Detail */}
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="titleRow">
                <div className="title">2. Employement Detail</div>
                <div className="req">Required</div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Job Title *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Job Title"
                      name="jobTitle"
                      value={data?.jobTitle}
                      onChange={(e) => onTextChange(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Department *</label>
                    <select
                      name="department"
                      value={data?.department}
                      id=""
                      className=""
                      onChange={(e) => onTextChange(e)}
                    >
                      <option value="">Select</option>
                      <option value="development">Development</option>
                      <option value="finance">Finance</option>
                      <option value="support">Support</option>
                      <option value="marketing">Marketing</option>
                      <option value="management">Management</option>
                      <option value="dispute">Dispute</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Employement Type *</label>
                    <select
                      name="employmentType"
                      value={data?.employmentType}
                      id=""
                      className=""
                      onChange={(e) => onTextChange(e)}
                    >
                      <option value="On-Site">Select</option>
                      <option value="full-time">Full-Time</option>
                      <option value="part-time">Part-Time</option>
                      <option value="intern">Intern</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Work Location *</label>
                    <select
                      name="workLocation"
                      value={data?.workLocation}
                      id=""
                      className=""
                      onChange={(e) => onTextChange(e)}
                    >
                      <option value="">Select</option>
                      <option value="on-site">On-Site</option>
                      <option value="hybrid">Hybrid</option>
                      <option value="remote">Remote</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Joining Date *</label>
                    <input
                      name="joiningDate"
                      value={data?.joiningDate}
                      type="date"
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Contract End Date</label>
                    <input
                      name="contractEndDate"
                      value={data?.contractEndDate}
                      type="date"
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 3. bank detail */}
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="titleRow">
                <div className="title">3. Payroll & Bank Information</div>
                <div className="req">Required</div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Base Salary</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Salary"
                      onChange={(e) => onTextChange(e)}
                      name="baseSalary"
                      value={data?.baseSalary}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Currency</label>
                    <select
                      name="currency"
                      value={data?.currency}
                      id=""
                      className=""
                      onChange={(e) => onTextChange(e)}
                    >
                      <option value="On-Site">Select</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="PKR">PKR</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Bank Account Holder Name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                      name="bankAccountHolderName"
                      value={data?.bankAccountHolderName}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Bank Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Bank Name"
                      onChange={(e) => onTextChange(e)}
                      name="bankName"
                      value={data?.bankName}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Account Number / IBAN </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Account Number / IBAN"
                      onChange={(e) => onTextChange(e)}
                      name="accountNumber"
                      value={data?.accountNumber}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>SWIFT/BIC Code </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter SWIFT/BIC Code"
                      onChange={(e) => onTextChange(e)}
                      name="swiftCode"
                      value={data?.swiftCode}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Tax ID / Social Security Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Tax ID / Social Security Number"
                      onChange={(e) => onTextChange(e)}
                      name="taxId"
                      value={data?.taxId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 4. system & Attendance Details */}
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="titleRow">
                <div className="title">4. System & Attendance Details</div>
                <div className="req">Required</div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Working Hours Policy *</label>
                    <input
                      type="text"
                      placeholder="e.g., 9–5, flexible, shift-based"
                      className="form-control"
                      onChange={(e) => onTextChange(e)}
                      name="workingHoursPolicy"
                      value={data?.workingHoursPolicy}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label>Overtime Eligibility *</label>
                    <div className="d-flex ai-center">
                      <span className="me-3">
                        Yes
                        <input
                          type="radio"
                          name="overtimeEligibility"
                          value={"yes"}
                          className="ms-1"
                          onChange={(e) => onTextChange(e)}
                        />
                      </span>
                      <span>
                        No
                        <input
                          type="radio"
                          name="overtimeEligibility"
                          value={"no"}
                          className="ms-1"
                          id=""
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 5. Document */}
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="titleRow">
                <div className="title">5. Document</div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="uploadCard">
                    <label>
                      {data?.nationalId ? (
                        "File Uploded"
                      ) : (
                        <img src={uploadImg} alt="upload" />
                      )}
                      <input
                        type="file"
                        name="nationalId"
                        onChange={onPDFChange}
                        accept=".pdf"
                      />
                    </label>
                    <div className="text-center">
                      National ID / Passport Copy (PDF)
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="uploadCard">
                    <label>
                      {data?.contract ? (
                        "File Uploded"
                      ) : (
                        <img src={uploadImg} alt="upload" />
                      )}
                      <input
                        type="file"
                        name="contract"
                        onChange={onPDFChange}
                        accept=".pdf"
                      />
                    </label>
                    <div className="text-center">
                      Contract / Offer Letter (PDF)
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="uploadCard">
                    <label>
                      {data?.otherDocument ? (
                        "File Uploded"
                      ) : (
                        <img src={uploadImg} alt="upload" />
                      )}
                      <input
                        type="file"
                        name="otherDocument"
                        onChange={onPDFChange}
                        accept=".pdf"
                      />
                    </label>
                    <div className="text-center">Other Documents (PDF)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card sortby-box br-10 border-transparent mt-3">
          <div className="card-header br-10  bg-white border-transparent py-3 ">
            <div className="empFormMain">
              <div className="" onClick={handleSubmit}>
                <button className="dashboardBtn">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
    </>
  );
};
